export const TOKEN_EXP_NOTIF_TIME = 30000;
// export const TOKEN_REFRESH_EVENTS = ["click", "mousedown", "keydown"];
const SmartPortailRHNotif = [
  {
    id: 1,
    label: 'Congé a validé',
    level: 3,
  },
  {
    id: 2,
    label: "Entretiens d'évaluation a rédiger",
    level: 5,
  },
];
const teamsRHNotif = [
  {
    id: 1,
    label: 'Processus en cours',
    level: 6,
  },
  {
    id: 2,
    label: 'Taches a realiser',
    level: 25,
  },
];

const KEYCLOAK_CLIENT_SUFFIXES = ['front', 'ui'];

export { SmartPortailRHNotif, teamsRHNotif, KEYCLOAK_CLIENT_SUFFIXES };

export const STORAGE_SERVICE_KEYS = {
  KC_ACTIVITY: {
    KEYCLOAK_SESSION: {
      key: 'keycloak-session',
      local: true,
    },
    KC_AUTH_TIME: {
      key: 'kc-auth-time',
      local: true,
    },
    KC_TAB_ID: {
      key: 'kc-tab-id',
      local: false, // sessionStorage (tab-specific, not shared across tabs)
    },
    TOKEN_EXP: {
      key: 'kc-token-exp',
      local: false, // sessionStorage
    },
    REFRESH_TOKEN_EXP: {
      key: 'kc-refresh-token-exp',
      local: false, // sessionStorage
    },
  },
};
